import api from '../../../utils/api';
import qs from 'querystringify';

export const getSystemProperties = async (type) => {
  const url = `/system-properties`;
  const params = {
    propertyType: type,
  };

  return api.get(url + qs.stringify(params, true));
};
